import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { ReactRendererSiteConfig } from '../types'

const reactRendererSiteConfig: SiteConfigFn<ReactRendererSiteConfig> = ({ api, funcLib }) => {
	const url = api.originalRequest.getUrl()
	const disabledComponents = funcLib.getQueryParamValue(url, 'disabledComponents', { toLowerCase: false })

	const disabledComponentsMap = funcLib.extractDisabledComponents(disabledComponents || '')
	const isBuilderComponentModel = !!api.rendererModel.getIsBuilderComponentModel()

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			disabledComponents: disabledComponentsMap,
			isBuilderComponentModel,
		},
	}
}

const name = 'renderer'

export const config = { site: reactRendererSiteConfig, name }
